import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CiudadService } from '../services/ciudad.service';
import { CiudadhmService } from '../services/ciudadhm.service';
import { ICiudadHM } from '../models/ciudadhm';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { ReporteService } from '../services/reporte.service';
import * as saveAs from 'file-saver';
import { ReporteriaService } from '../services/reporteria.service';
import { ICiudad } from '../models/ciudad';
import { CiudadesprincipalesService } from '../services/ciudadesprincipales.service';
import { ICiudadPrincipalHM } from '../models/ciudadprincipal';
import { SemanaService } from '../services/semana.service';

@Component({
  selector: 'app-reporteria',
  templateUrl: './reporteria.component.html',
  styleUrls: ['./reporteria.component.scss']
})
export class ReporteriaComponent {


  constructor(private ciudades: CiudadhmService,
    private ciudadprincipal: CiudadService,
    private semanasNominaService: SemanaService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private reporteService: ReporteriaService,
    private ciudadesprincipalesService: CiudadesprincipalesService
  ) { }
  ngOnInit(): void {
    this.anio_filtro = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    this.cargarciudadeshm();
    this.cargarciudades()
    this.semanasLst(0);
  }
  // filtrosForm:any
  // filtrosForm: FormGroup;
  lstSemanasInfo: any[] = [];
  lstAniosInfo: any[] = [];
  fec_inicio: string = ''
  fec_fin: string = ''
  reportes = [
    {
      id_reporte: 1,
      titulo: 'Asistencia Pagada',
      descripcion: 'Muestra los días trabajados con pago, incluyendo permisos con goce de sueldo.',
      fec_inicio: null,
      fec_fin: null,
      id_semana: null,
      num_anio: 0,
      ciudad: 0
    },
    {
      id_reporte: 2,
      titulo: 'Descanso Laborado',
      descripcion: 'Registra los días de descanso en los que el colaborador laboró y generó pago extra.',
      fec_inicio: null,
      fec_fin: null,
      id_semana: null,
      num_anio: 0,
      ciudad: 0
    },
    {
      id_reporte: 3,
      titulo: 'Descansos y Faltas',
      descripcion: 'Incluye los días en los que el colaborador Descnaso o Falto distinguiendolo por evento.',
      fec_inicio: null,
      fec_fin: null,
      id_semana: null,
      num_anio: 0,
      ciudad: 0
    },
    {
      id_reporte: 4,
      titulo: 'Extensión de Ruta',
      descripcion: 'Reporte de recorridos fuera de la ruta habitual asignada al operador.',
      fec_inicio: null,
      fec_fin: null,
      id_semana: null,
      num_anio: 0,
      ciudad: 0
    },
    {
      id_reporte: 5,
      titulo: 'Servicios Semanal por Ciudad',
      descripcion: 'Reporte de Servicios Semanal por Ciudad.',
      fec_inicio: null,
      fec_fin: null,
      id_semana: null,
      num_anio: 0,
      ciudad: 0
    }
  ];


  lstciudadeshm: ICiudadHM[] = [];

  ciudadhm: number = 0;
  cargarciudadeshm() {
    this.ciudades.getListadoCiudades().subscribe((resp) => {
      this.lstciudadeshm = resp;
      setTimeout(() => {
      }, 400);
    }, (error) => {
      this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de Ciudades');
    }
    )
  }

  lstciudadesprin: ICiudadPrincipalHM[] = [];
  cargarciudades() {
    this.ciudadesprincipalesService.getListadoCiudadesPrincipales().subscribe((resp) => {
      this.lstciudadesprin = resp;
      setTimeout(() => {
      }, 400);
    }, (error) => {
      this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de Ciudades');
    });
  }

  cargarListadoDeCiudadesPrincipales() {

  }

  // const anio_cast = this.selectYear instanceof Date ? this.selectYear.getFullYear() : this.selectYear;

  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '. <b>Verifique la informacion.</b>';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
  }

  reporte: any
  anio_filtro: any
  cargarListadoDeSemanasAnio_cast(anio_filtro: any) { }

  seleccionarReporte(reporte: any) {

  }


  verReporte(id_reporte: any, fec_inicio: any, fec_fin: any, ciudad: any, id_semana: any, num_anio: any) {

    switch (id_reporte) {
      case 1:
        this.exportarExcelAsistenciaPagada(id_reporte, fec_inicio, fec_fin, ciudad)
        break;
      case 2:
        this.exportardescansolaborado(id_reporte, fec_inicio, fec_fin, ciudad)
        break;
      case 3:
        this.exportarExcelfaltas(id_reporte, fec_inicio, fec_fin, ciudad)
        break;
      case 4:
        this.exportarextencion(id_reporte, fec_inicio, fec_fin, ciudad)
        break;
      case 5:
        this.exportServiciosNomina(id_reporte, id_semana, num_anio, ciudad)
        break;
    }

  }
  loading: boolean = false;


  exportarExcelfaltas(id_reporte: any, fec_inicio: any, fec_fin: any, ciudad: any) {
    this.loading = true;
    if (fec_inicio == '' || fec_inicio == null || fec_fin == '' || fec_fin == null || ciudad == 0 || ciudad == null) {
      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar todos los parametros solicitados.' });
      this.loading = false;
      return
    }

    if (fec_inicio > fec_fin) {
      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar una fecha inicio menor a la fecha fin.' });
      this.loading = false;
      return
    }

    let ciudadrpt = this.lstciudadeshm.find(x => x.id == ciudad)
    this.reporteService.getrptfaltas(ciudad, fec_inicio.substring(0, 10), fec_fin.substring(0, 10))
      .subscribe((resp: any[]) => {
        if (resp.length === 0 || typeof resp === 'undefined') {
          this.mostrarDialogoInformativoSinInformacion(
            '<b>Aviso:</b> No se encontraron registros con los parámetros seleccionados. Verifique la información ingresada antes de exportar el catálogo a Excel.');
          this.loading = false;
        } else {
          import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(resp);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer: any = xlsx.write(workbook, {
              bookType: "xlsx",
              type: "array"
            });
            this.saveAsExcelFile(excelBuffer, "Descansos&FaltasColaborador_" + ciudadrpt?.nombre + '_periodo_del_' + fec_inicio.substring(0, 10) + '_al_' + fec_fin.substring(0, 10));
          });
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      },
        (error) => {
          this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en emitir el reporte.' });
           this.loading = false;
        });
  }

  exportardescansolaborado(id_reporte: any, fec_inicio: any, fec_fin: any, ciudad: any) {

    this.loading = true;
    if (fec_inicio == '' || fec_inicio == null || fec_fin == '' || fec_fin == null || ciudad == 0 || ciudad == null) {
      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar todos los parametros solicitados.' });
      this.loading = false;
      return
    }
    if (fec_inicio > fec_fin) {
      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar una fecha inicio menor a la fecha fin.' });
      this.loading = false;
      return
    }
    let ciudadrpt = this.lstciudadeshm.find(x => x.id == ciudad)
    this.reporteService.getrpdescansolab(ciudad, fec_inicio.substring(0, 10), fec_fin.substring(0, 10))
      .subscribe((resp: any[]) => {
        if (resp.length === 0 || typeof resp === 'undefined') {
          this.mostrarDialogoInformativoSinInformacion(
            '<b>Aviso:</b> No se encontraron registros con los parámetros seleccionados. Verifique la información ingresada antes de exportar el catálogo a Excel.');
          this.loading = false;
        } else {
          import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(resp);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer: any = xlsx.write(workbook, {
              bookType: "xlsx",
              type: "array"
            });
            this.saveAsExcelFile(excelBuffer, "DescansoLaborado_" + ciudadrpt?.nombre + + '_periodo_del_' + fec_inicio.substring(0, 10) + '_al_' + fec_fin.substring(0, 10));
          });
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      },
        (error) => {
          this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en emitir el reporte.' });
           this.loading = false;
        });
  }


  exportarExcelAsistenciaPagada(id_reporte: any, fec_inicio: any, fec_fin: any, ciudad: any,) {
    this.loading = true;
    if (fec_inicio == '' || fec_inicio == null || fec_fin == '' || fec_fin == null || ciudad == 0 || ciudad == null) {
      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar todos los parametros solicitados.' });
      this.loading = false;
      return
    }

    if (fec_inicio > fec_fin) {
      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar una fecha inicio menor a la fecha fin.' });
      this.loading = false;
      return
    }


    let ciudadrpt = this.lstciudadeshm.find(x => x.id == ciudad)
    this.reporteService.getrptasistenciapagada(ciudad, fec_inicio.substring(0, 10), fec_fin.substring(0, 10))
      .subscribe((resp: any[]) => {
        if (resp.length === 0 || typeof resp === 'undefined') {
          this.mostrarDialogoInformativoSinInformacion(
            '<b>Aviso:</b> No se encontraron registros con los parámetros seleccionados. Verifique la información ingresada antes de exportar el catálogo a Excel.');
          this.loading = false;
        } else {
          import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(resp);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer: any = xlsx.write(workbook, {
              bookType: "xlsx",
              type: "array"
            });
            this.saveAsExcelFile(excelBuffer, "AsistenciaPagada_" + ciudadrpt?.nombre + '_periodo_del_' + fec_inicio.substring(0, 10) + '_al_' + fec_fin.substring(0, 10));
          });
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      },
        (error) => {
          this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en emitir el reporte.' });
         this.loading = false;
         });
  }



  exportarextencion(id_reporte: any, fec_inicio: any, fec_fin: any, ciudad: any) {
    this.loading = true;
    if (fec_inicio == '' || fec_inicio == null || fec_fin == '' || fec_fin == null || ciudad == 0 || ciudad == null) {
      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar todos los parametros solicitados.' });
      this.loading = false;
      return
    }
    if (fec_inicio > fec_fin) {
      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar una fecha inicio menor a la fecha fin.' });
      this.loading = false;
      return
    }


    let ciudadrpt = this.lstciudadesprin.find(x => x.id == ciudad)
    this.reporteService.getrptextension(ciudad, fec_inicio.substring(0, 10), fec_fin.substring(0, 10))
      .subscribe((resp: any[]) => {
        if (resp.length === 0 || typeof resp === 'undefined') {
          this.mostrarDialogoInformativoSinInformacion(
            '<b>Aviso:</b> No se encontraron registros con los parámetros seleccionados. Verifique la información ingresada antes de exportar el catálogo a Excel.');
          this.loading = false;
        } else {
          import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(resp);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer: any = xlsx.write(workbook, {
              bookType: "xlsx",
              type: "array"
            });
            this.saveAsExcelFile(excelBuffer, "FaltasPorColaborador_" + ciudadrpt?.nombre + + '_periodo_del_' + fec_inicio.substring(0, 10) + '_al_' + fec_fin.substring(0, 10));
          });
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      },
        (error) => {
          this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en emitir el reporte.' });
          this.loading = false;
           });
  }
  
  semanasLst(num_anio: number) {
    let mssg = num_anio==0||num_anio==null ? 'Años' : 'Semanas' + num_anio;
    this.lstSemanasInfo= [];
    this.semanasNominaService.getLstSemanasInfo(num_anio)
      .subscribe((resp: any[]) => {
        if (resp.length === 0 || typeof resp === 'undefined') {
          this.mostrarDialogoInformativoSinInformacion(
            '<b>Aviso:</b> No fueron posible cargar <b>'+ mssg +'</b>. Verifique la su conexion a internet y/o contacte a Administrador.');
        } else {
          if(num_anio==0||num_anio==null){
            this.lstAniosInfo = resp;
          }else{
            setTimeout(() => {
            this.lstSemanasInfo = resp;
          }, 500);
          }
        }
      },
      (error) => {
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error al obtener info '+ mssg+'.' });
      });
  }

  exportServiciosNomina(id_reporte: any, id_semana: any, num_anio: any, ciudad: any) {
    this.loading = true;
    if (id_semana == '' || id_semana == null || num_anio == '' || num_anio == null || ciudad == 0 || ciudad == null) {
      this.messageService.add({ severity: 'warn', summary: 'Campos incorrectos', detail: 'Debes seleccionar todos los parametros solicitados.' });
      this.loading = false;
      return
    }
    let ciudadrpt = this.lstciudadeshm.find(x => x.id == ciudad);

    this.reporteService.getrptServiciosNomina(id_semana,num_anio,ciudad)
      .subscribe((resp: any[]) => {
        if (resp.length === 0 || typeof resp === 'undefined') {
          this.mostrarDialogoInformativoSinInformacion(
            '<b>Aviso:</b> No se encontraron registros con los parámetros seleccionados. Verifique la información ingresada antes de exportar el catálogo a Excel.');
          this.loading = false;
        } else {
          import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(resp);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer: any = xlsx.write(workbook, {
              bookType: "xlsx",
              type: "array"
            });
            this.saveAsExcelFile(excelBuffer, "ReporteServiciosSemanal_" + ciudadrpt?.nombre + "_" + id_semana + "_Semana_" + num_anio);
          });
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      },
      (error) => {
        this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en emitir el reporte.' });
        this.loading = false;
      });
  }


  saveAsExcelFile(buffer: any, fileName: string): void {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName + "_exportar_" + dateFormat + EXCEL_EXTENSION);
  }
}
